import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["canvas", "arrivals", "currentCount"]

  static values = {
    intervalSeconds: { type: Number, default: 60 },
    maxPoints: { type: Number, default: 120 }
  }

  connect() {
    this.labels = [this.timeLabel(new Date())]
    this.counts = [0]

    this.observer = new MutationObserver((mutations) => this.recordArrivals(mutations))
    this.observer.observe(this.arrivalsTarget, { childList: true })
    this.consumeArrivals(Array.from(this.arrivalsTarget.children))

    this.timer = window.setInterval(
      () => this.startInterval(),
      this.intervalSecondsValue * 1000
    )
  }

  disconnect() {
    this.observer?.disconnect()
    window.clearInterval(this.timer)
  }

  recordArrivals(mutations) {
    const arrivals = mutations.flatMap((mutation) => Array.from(mutation.addedNodes))

    this.consumeArrivals(arrivals)
  }

  consumeArrivals(arrivals) {
    let recordedCount = 0

    arrivals.forEach((arrival) => {
      if (!(arrival instanceof HTMLElement) || !arrival.dataset.delayedJobRecordedAt) return

      this.counts[this.counts.length - 1] += 1
      recordedCount += 1
      arrival.remove()
    })

    if (recordedCount > 0) this.updateChart()
  }

  startInterval() {
    this.labels.push(this.timeLabel(new Date()))
    this.counts.push(0)

    if (this.labels.length > this.maxPointsValue) {
      this.labels.shift()
      this.counts.shift()
    }

    this.updateChart()
  }

  updateChart() {
    this.currentCountTarget.textContent = this.counts[this.counts.length - 1]

    const data = JSON.parse(this.canvasTarget.dataset.chartjsDataValue)
    data.labels = this.labels
    data.datasets[0].data = this.counts
    this.canvasTarget.dataset.chartjsDataValue = JSON.stringify(data)
  }

  timeLabel(date) {
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" })
  }
}
